import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { PlusCircle } from "lucide-react";
import { useBotPhotos } from "../../hooks/useBotPhotos";
import BotAvatar from "../BotAvatar/BotAvatar";
import "./BotSelector.css";

export default function BotSelector({ bots = [], selectedBot, onSelect, allBotsOption = true }) {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const navigate = useNavigate();
  const photoUrls = useBotPhotos(bots);

  const hasBots = Array.isArray(bots) && bots.length > 0;
  const botsList = Array.isArray(bots) ? bots : [];

  function toggleDropdown() {
    setDropdownOpen(open => !open);
  }

  function handleSelect(bot) {
    onSelect(bot);
    setDropdownOpen(false);
  }

  function handleSelectAll() {
    onSelect(null);
    setDropdownOpen(false);
  }

  return (
    <>
      {/* HEADER / BOT ATUAL (IGUAL SIDEBAR) */}
      <div className="bot-selector-header relative">
        <div
          className={`filter-dropdown-trigger overflow-y-none ${dropdownOpen ? "open" : ""}`}
          onClick={toggleDropdown}
        >
          <span style={{ display: 'flex', alignItems: 'center', gap: 7 }}>
            {selectedBot && (
              <BotAvatar photoUrl={photoUrls[selectedBot.id]} size={32} />
            )}
            {selectedBot
              ? selectedBot.bot_username || selectedBot.bot_name
              : "Todos os Bots"}
          </span>

          <i className="fas fa-chevron-down" />
        </div>

        {/* WRAPPER */}
        <div className="bot-selector-wrapper-2 z-10 relative">
          {/* DROPDOWN */}
          {dropdownOpen && (
            <div className="filter-dropdown-container">
              {/* Opção "Todos os Bots" */}
              {allBotsOption && (
                <div
                  className={`filter-dropdown-item ${!selectedBot ? 'selected' : ''}`}
                  onClick={handleSelectAll}
                >
                  Todos os Bots
                </div>
              )}

              {hasBots ? (
                botsList.map(bot => {
                  const isActive = String(bot.id) === String(selectedBot?.id);
                  const isInactive = bot?.is_active === false;

                  return (
                    <div
                      key={bot.id}
                      className={`filter-dropdown-item ${isActive ? "selected" : ""} ${isInactive ? "inactive" : ""}`}
                      onClick={() => handleSelect(bot)}
                      style={{ display: 'flex', alignItems: 'center', gap: 8 }}
                    >
                      <BotAvatar photoUrl={photoUrls[bot.id]} size={28} />
                      <span>
                        {bot.bot_username || bot.bot_name || `Bot #${bot.id}`}
                        {isInactive && " - Inativo"}
                      </span>
                    </div>
                  );
                })
              ) : (
                <>
                  <div
                    className="filter-dropdown-item"
                    style={{ opacity: 0.5, cursor: "default" }}
                  >
                    <i className="fas fa-info-circle dropdown-icon"></i>
                    Nenhum bot cadastrado
                  </div>

                  <div
                    className="filter-dropdown-item"
                    style={{
                      background: "rgba(59,130,246,0.1)",
                      color: "#3b82f6",
                      fontWeight: 500,
                    }}
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/bots/create");
                    }}
                  >
                    <PlusCircle size={14} className="dropdown-icon" />
                    Criar primeiro bot
                  </div>
                </>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
}
